// router 목록 import
import common from '@router/module/common';
import user from '@router/module/user';
import admin from '@router/module/admin';

const routes = () => [...common, ...user, ...admin];

export default routes();